import { Bookmark, Headphones } from "lucide-react";

const previewRows = [
  {
    episode: "Attention Is a Place We Choose to Live",
    note: "Return to the section on public space.",
    rating: "4 / 5",
    status: "Listening",
  },
  {
    episode: "The Tools That Teach Us How to Think",
    note: "Useful for the tools essay.",
    rating: "5 / 5",
    status: "Finished",
  },
  {
    episode: "Building a More Patient Internet",
    note: "—",
    rating: "—",
    status: "Unplayed",
  },
];

// Preview one public Podcast source with private listener overlays without
// making the entire product feel like a generic database grid.
export function TrackingPreview() {
  return (
    <div className="paper-card overflow-hidden rounded-2xl">
      <div className="flex items-center justify-between border-b px-5 py-4">
        <div>
          <p className="font-serif text-lg font-semibold">The Long Signal</p>
          <p className="text-muted-foreground mt-0.5 text-xs">
            Public Podcast source
          </p>
        </div>
        <span className="bg-muted rounded-full px-3 py-1.5 font-mono text-[9px] tracking-[0.1em] uppercase">
          Private overlays
        </span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full min-w-[42rem] border-collapse text-left">
          <thead>
            <tr className="text-muted-foreground bg-muted/45 border-b font-mono text-[9px] tracking-[0.1em] uppercase">
              <th className="px-5 py-3 font-medium">Episode</th>
              <th className="px-4 py-3 font-medium">Status</th>
              <th className="px-4 py-3 font-medium">Rating</th>
              <th className="px-4 py-3 font-medium">Episode note</th>
              <th className="px-4 py-3 font-medium">Keep</th>
            </tr>
          </thead>
          <tbody className="divide-y">
            {previewRows.map((row, index) => {
              return (
                <tr key={row.episode}>
                  <td className="px-5 py-4">
                    <span className="flex items-center gap-2 font-medium">
                      <Headphones className="text-primary size-3.5 shrink-0" />
                      {row.episode}
                    </span>
                  </td>
                  <td className="px-4 py-4">
                    <span className="bg-secondary text-secondary-foreground rounded-full px-2.5 py-1 text-xs">
                      {row.status}
                    </span>
                  </td>
                  <td className="px-4 py-4 font-mono text-xs">{row.rating}</td>
                  <td className="text-muted-foreground px-4 py-4 text-sm">
                    {row.note}
                  </td>
                  <td className="px-4 py-4 text-center">
                    <Bookmark
                      className={
                        index < 2
                          ? "fill-primary text-primary mx-auto size-4"
                          : "text-muted-foreground mx-auto size-4"
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
